module.exports = __webpack_public_path__ + "img/894b78d.png";